import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import ContentNavigationBar from './ContentNavigationBar';
import './PresentationAnalysisCenterPanel.css';

const PresentationAnalysisCenterPanel = ({ 
  presentationContent, 
  loading, 
  error,
  activeSection,
  onSectionClick
}) => {
  if (loading) {
    return (
      <div className="presentation-center-panel">
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Analyzing presentation...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="presentation-center-panel">
        <div className="error-state">
          <p>Error: {error}</p>
        </div>
      </div>
    );
  }

  if (!presentationContent) {
    return (
      <div className="presentation-center-panel">
        <div className="empty-state">
          <h3>Earnings Presentation Analysis</h3>
          <p>Select a bank, year, quarter, and segment to begin analysis.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="presentation-center-panel">
      <div className="analysis-content">
        <ReactMarkdown 
          remarkPlugins={[remarkGfm]}
          components={{
            h1: ({ children, ...props }) => {
              const text = children.toString().replace(/\*\*/g, '').replace(/\*/g, '').trim();
              const sectionId = text.toLowerCase().replace(/[^a-z0-9]/g, '-');
              return <h1 id={sectionId} className="markdown-h1" {...props}>{children}</h1>;
            },
            h2: ({ children, ...props }) => {
              const text = children.toString().replace(/\*\*/g, '').replace(/\*/g, '').trim();
              const sectionId = text.toLowerCase().replace(/[^a-z0-9]/g, '-');
              return <h2 id={sectionId} className="markdown-h2" {...props}>{children}</h2>;
            },
            h3: ({ children, ...props }) => {
              const text = children.toString().replace(/\*\*/g, '').replace(/\*/g, '').trim();
              const sectionId = text.toLowerCase().replace(/[^a-z0-9]/g, '-');
              return <h3 id={sectionId} className="markdown-h3" {...props}>{children}</h3>;
            },
            h4: (props) => <h4 className="markdown-h4" {...props} />,
            h5: (props) => <h5 className="markdown-h5" {...props} />,
            h6: (props) => <h6 className="markdown-h6" {...props} />,
            p: (props) => <p className="markdown-p" {...props} />,
            strong: (props) => <strong className="markdown-strong" {...props} />,
            em: (props) => <em className="markdown-em" {...props} />,
            ul: (props) => <ul className="markdown-ul" {...props} />,
            ol: (props) => <ol className="markdown-ol" {...props} />,
            li: (props) => <li className="markdown-li" {...props} />,
            table: (props) => <table className="markdown-table" {...props} />,
            thead: (props) => <thead className="markdown-thead" {...props} />,
            tbody: (props) => <tbody className="markdown-tbody" {...props} />,
            tr: (props) => <tr className="markdown-tr" {...props} />,
            th: (props) => <th className="markdown-th" {...props} />,
            td: (props) => <td className="markdown-td" {...props} />,
            code: (props) => <code className="markdown-code" {...props} />,
            pre: (props) => <pre className="markdown-pre" {...props} />,
            blockquote: (props) => <blockquote className="markdown-blockquote" {...props} />,
            hr: (props) => <hr className="markdown-hr" {...props} />,
          }}
        >
          {presentationContent}
        </ReactMarkdown>
      </div>
      
      {/* Content Navigation Bar */}
      <ContentNavigationBar
        content={presentationContent}
        activeSection={activeSection}
        onSectionClick={onSectionClick}
      />
    </div>
  );
};

export default PresentationAnalysisCenterPanel;

